/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */

import { desktopPlatforms, originType, platformType, webPlatforms } from './analyticsWebTypes';
import { isType } from './isType';
import { objectValues } from './objectValues';
import { type ProductInfoType } from './types';

export function validatePlatform(productInfo: ProductInfoType): void {
	if (!isType(platformType, productInfo.platform)) {
		throw new Error(
			`Invalid productInfo.platform '${productInfo.platform}', ` +
				`must be a platformType: [${objectValues(platformType)}]`,
		);
	}

	if (
		productInfo.origin === originType.DESKTOP &&
		!isType(desktopPlatforms, productInfo.platform)
	) {
		throw new Error(
			`Invalid productInfo.platform '${productInfo.platform}', ` +
				'must be one of [mac, linux, windows]',
		);
	}

	if (productInfo.origin === originType.WEB && !isType(webPlatforms, productInfo.platform)) {
		throw new Error(
			`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`,
		);
	}
}
